import { FlatList, Pressable, View } from 'react-native';
import { styles } from './styles';
import { Icon } from '@/components/Icon';
import colors from '@/config/colors';
import { Text } from '@/components/Text';

interface ExpiredDigaCodesProps {
  expiredCodesList: { digaCode: string; expireAt: string }[];
  isExpiredCodesExpanded: boolean;
  setIsExpiredCodesExpanded: (value: boolean) => void;
}

export const ExpiredDigaCodes = ({
  expiredCodesList,
  isExpiredCodesExpanded,
  setIsExpiredCodesExpanded,
}: ExpiredDigaCodesProps) => {
  return (
    <View style={styles.cardContainer}>
      <Text style={styles.cardLabel}>Bisher eingelöste Rezeptcodes </Text>
      <Text style={styles.secondInfoText}>
        {
          <Text style={styles.digaCodeList}>
            <Text>{expiredCodesList[0].digaCode}</Text> (abgelaufen am{' '}
            {expiredCodesList[0].expireAt})
          </Text>
        }
      </Text>

      {expiredCodesList.length > 1 ? (
        <>
          <Pressable
            onPress={() => setIsExpiredCodesExpanded(!isExpiredCodesExpanded)}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              paddingVertical: 10,
              marginTop: 5,
            }}
          >
            <Icon
              name={isExpiredCodesExpanded ? 'chevronUp' : 'chevronDown'}
              size={20}
              color={colors.primary}
              style={{ marginRight: 8 }}
            />
            <Text style={[{ color: colors.primary }]}>
              {isExpiredCodesExpanded
                ? `${expiredCodesList.length - 1} weitere Rezeptcode${expiredCodesList.length > 2 ? 's' : ''} ausblenden`
                : `${expiredCodesList.length - 1} weitere Rezeptcode${expiredCodesList.length > 2 ? 's' : ''} anzeigen`}
            </Text>
          </Pressable>

          {isExpiredCodesExpanded ? (
            <FlatList
              data={expiredCodesList.slice(1)}
              renderItem={({ item }) => (
                <Text style={styles.digaCodeList}>
                  <Text>{item.digaCode}</Text> (abgelaufen am {item.expireAt})
                </Text>
              )}
              keyExtractor={(item) => item.digaCode}
              scrollEnabled={false}
            />
          ) : null}
        </>
      ) : null}
    </View>
  );
};
